import { camelCase, snakeCase } from 'lodash';
import { transformKeys } from '@fiverr-private/futile/lib/object';

const toSnakeCase = (obj) => transformKeys(obj, snakeCase);

const toCamelCase = (obj) => transformKeys(obj, camelCase);

export default {
    toSnakeCase,
    toCamelCase
};
